export default "__VITE_ASSET__C$K5MD6M__"